import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import AWSOps, { appConfig } from '../config/AWSOps';
import * as types from '../constants/ActionTypes';

export const membersLoading = loading => ({
  type: types.MEMBERS_LOADING,
  loading,
});
export const membersLoaded = members => ({
  type: types.MEMBERS_LOADED,
  members,
});

export const getMembers = () => async (dispatch) => {
  dispatch(membersLoading(true));
  return new Promise((resolve, reject) => {
    const params = {
      UserPoolId: appConfig.UserPoolId,
    };
    const provider = new AWSOps.CognitoIdentityServiceProvider();
    provider.listUsers(params, (error, data) => {
      if (error) {
        dispatch(membersLoading(false));
        reject(error);
      }
      const members = _.map([...data.Users], item => ({
        enabled: item.Enabled,
        createdAt: item.UserCreateDate,
        updatedAt: item.UserLastModifiedDate,
        status: item.UserStatus,
        username: item.Username,
        attrs: _.map(item.Attributes, attr => ({ [attr.Name]: attr.Value })),
        sub: _.result(_.find(item.Attributes, { Name: 'sub' }), 'Value'),
        role:
          _.result(_.find(item.Attributes, { Name: 'custom:role' }), 'Value') ||
          '',
      }));
      const memberSchema = new schema.Entity(
        'members',
        {},
        { idAttribute: 'sub' }
      );
      const memberList = new schema.Array(memberSchema);
      const normalizedMembers = normalize(members, memberList);
      dispatch(membersLoaded(normalizedMembers));
      resolve(normalizedMembers);
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/MemberActions.js